import { QueryType } from 'typings/common.type';
import { handleParams } from 'utils/common.util';

// Routes ///////////////////////////////////////////////////////////////
export const HomeRoute = (): string => `/`;
export const LoginRoute = (next?: QueryType, referrer?: QueryType): string =>
  `/account/login-otp/${handleParams(next, referrer)}`;
export const ForgetPasswordRoute = (
  next?: QueryType,
  referrer?: QueryType,
): string => `/account/forget-password/${handleParams(next, referrer)}`;
export const ForgetPasswordSecondStepRoute = (
  next?: QueryType,
  referrer?: QueryType,
): string =>
  `/account/forget-password-second-step/${handleParams(next, referrer)}`;
export const LoginWithOtpSecondStep = (
  next?: QueryType,
  referrer?: QueryType,
): string => `/account/login-otp-second-step/${handleParams(next, referrer)}`;
export const LoginWithPasswordRoute = (
  next?: QueryType,
  referrer?: QueryType,
): string => `/account/login/${handleParams(next, referrer)}`;
export const OnboardingRoute = (
  next?: QueryType,
  referrer?: QueryType,
): string => `/account/onboarding/${handleParams(next, referrer)}`;

// API //////////////////////////////////////////////////////////////////
export const CaptchaUrl = (): string => `/api/v1/captcha/`;
export const LoginWithPasswordUrl = (): string => `/api/v1/account/login/`;
export const RequestOtpV1Url = (): string => `/api/v1/account/otp/request/`;
export const RequestOtpV2Url = (): string => `/api/v2/accounts/otp/request/`;
export const VerifyOtpV2Url = (): string => `/api/v2/accounts/otp/verify/`;
export const VerifyOtpV1Url = (): string => `/api/v1/account/otp/`;
export const ChangePasswordUrl = (): string =>
  `/api/v1/account/change_password/`;
export const LogoutUrl = (): string => `/api/v1/account/logout/`;
export const RefreshTokenUrl = (): string => `/api/v1/account/refresh/`;

// login with password url => /api/v1/account/login/

// receive otp request for signup and forgot password => /api/v1/account/otp/request/
// verify otp code for signup and forgot password => /api/v1/account/otp/

// receive otp for login without password => /api/v2/accounts/otp/request/
// verify otp code for login without password => /api/v2/accounts/otp/verify/

// change password => /api/v1/account/change_password/
